import { iconComp } from "../../data/iconComp";

export default function WriteIcon({
  code,
  textExists,
}: {
  code: string | boolean | undefined;
  textExists: boolean;
}) {
  let Comp: any = null;
  if (typeof code === "string" && code !== "loading" && code in iconComp) {
    Comp = iconComp[code].Comp;
  }

  return Comp || code === "loading" ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        paddingBottom: code === "loading" && !textExists ? 0 : 10,
      }}
    >
      {code === "loading" ? (
        <div className="spinner" />
      ) : typeof code === "string" && Comp ? (
        <Comp
          style={{
            color: iconComp[code].color,
            fontSize: 60,
          }}
        />
      ) : (
        <></>
      )}
    </div>
  ) : (
    <></>
  );
}
